var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0664062,
    y: 0.0839844,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#111219"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0654,
    cy: 12.0723,
    r: 3.90215,
    fill: "#F2F6F9",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0664 2.65625V5.01205",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0664 19.1562V21.5121",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2305 7.37012L18.1903 8.54802",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94141 15.6201L3.90122 16.798",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2305 16.7979L18.1903 15.62",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94141 8.54785L3.90122 7.36995",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun1);
export default __webpack_public_path__ + "static/media/sun1.63edbdb1a86e3baf64ff975c370e4970.svg";
export { ForwardRef as ReactComponent };